const APPOINTMENT_TYPES = {
  REQUIRES_APT: 'requiresAPT',
  IGNORE_APT: 'ignoreAPT'
};
const EQUIPMENT_FLOW = {
  FIXED: "Fixed",
  FLEXIBLE: "Flexible"
}

const EQUIPMENT_TYPES = {
  FIXED_LENGTH: 'fixed',
  MAX_LENGTH: 'max',
  MIN_LENGTH: 'min'
};

const EQUIPMENT_TYPE_BY_FIELD  = {
  minEquipmentSize: EQUIPMENT_TYPES.MIN_LENGTH,
  maxFeasibleTrailerLength: EQUIPMENT_TYPES.MAX_LENGTH,
  fixedEquipmentSize: EQUIPMENT_TYPES.FIXED_LENGTH
};

const APPOINTMENT_RADIO_OPTIONS = [
  { 
    value: APPOINTMENT_TYPES.REQUIRES_APT, 
    labelText: 'Requires Appointment', 
    featureFlag: "enableRequiresAppointmentInCustomerManagement" 
  },
  { 
    value: APPOINTMENT_TYPES.IGNORE_APT, 
    labelText: 'Ignore Appointment', 
    featureFlag: "enableIgnoreAppointmentInCustomerManagement" 
  }
];

const CLOSED_WINDOW_LABEL = 'Closed';

const CONTACT_SECTION_TITLES = {
  DELIVERY: 'Delivery Contact',
  PICKUP: 'Pickup Contact'
};

const CUSTOMER_DETAILS = {
  DELIVERY: 'deliveryDetails',
  PICKUP: 'pickupDetails'
};

const EDIT_CUSTOMER_FORM_MAP_SPLIT_LAYOUT = {
  initialLeftWidth: { percent: 0.6, min: 620, max: 1000 },
  minLeftWidth: 620,
  minRightWidth: 280
};

export {
  APPOINTMENT_TYPES,
  APPOINTMENT_RADIO_OPTIONS,
  EQUIPMENT_TYPES,
  EQUIPMENT_TYPE_BY_FIELD,
  EQUIPMENT_FLOW,
  CLOSED_WINDOW_LABEL,
  CONTACT_SECTION_TITLES,
  CUSTOMER_DETAILS,
  EDIT_CUSTOMER_FORM_MAP_SPLIT_LAYOUT
};
